import { FC, useState } from 'react'
import { CaretDown } from '@components/icons'

interface Props {
  items?: any
}

const ns = `site-footer`

const Accordion: FC<Props> = ({ items = [] }) => {
  const [isActive, setActive] = useState<string | null>(null)
  const toggleClass = (id: string) => {
    setActive((isActive) => (isActive === id ? null : id))
  }

  return items.map((item: any) => {
    const id = item.categoryTitle.replace(/\s/g, '')

    return (
      <div className={`${ns}__accordion__item`} key={id}>
        <div
          className={`${ns}__accordion__item-label ${ns}__accordion__item-label${
            isActive === id ? '-active' : ''
          }`}
          onClick={() => toggleClass(id)}
        >
          {item.categoryTitle}
          <div
            className={`${ns}__accordion__item-icon ${ns}__accordion__item-icon${
              isActive === id ? '-open' : ''
            }`}
          >
            <CaretDown width={16} height={16} color="white" />
          </div>
        </div>
        <div
          className={`${ns}__accordion__item-content ${ns}__accordion__item-content${
            isActive === id ? '-active' : ''
          }`}
        >
          {(item.linkListCollection?.items || []).map((item: any) => (
            <a
              href={item.target}
              key={item.target}
              className={`${ns}__accordion__item-link`}
            >
              <h6>{item.label}</h6>
            </a>
          ))}
        </div>
      </div>
    )
  })
}

export default Accordion
